// extracted by mini-css-extract-plugin
export var colorSquare = "_o7-0";
export var container = "_o7-h";
export var danger = "_o7-5";
export var lightPink = "_o7-8";
export var neutralBlue = "_o7-7";
export var neutralYellow = "_o7-6";
export var normal = "_o7-1";
export var primary = "_o7-2";
export var primaryLight = "_o7-3";
export var selected = "_o7-i";
export var solidBlack = "_o7-g";
export var solidGreen = "_o7-b";
export var solidLightBlue = "_o7-d";
export var solidNavy = "_o7-c";
export var solidOrange = "_o7-f";
export var solidPink = "_o7-e";
export var solidRed = "_o7-9";
export var solidYellow = "_o7-a";
export var success = "_o7-4";